// extracted by mini-css-extract-plugin
export default {"labelArea":"InfoCell__labelArea___bQMT6","label":"InfoCell__label___v0px7","hint":"InfoCell__hint___gnX00","fieldData":"InfoCell__fieldData___HOxCK"};